module.exports = __webpack_public_path__ + "img/Slardar.66d8c310.png";